import React, { useCallback, useContext, useMemo, useState } from "react";

type IsPendingAllowedKey =
  | "general_access"
  | "invite_new"
  | `invitation_${string}`
  | `member_${string}`
  | "refetching";

export const ConfigContext = React.createContext<{
  isPending: boolean;
  setIsPending: (key: IsPendingAllowedKey, value: boolean) => void;
}>({
  isPending: false,
  setIsPending: () => {
    throw new Error("setIsPending function must be overridden");
  },
});

interface ShareModalContextProviderProps {
  children?: React.ReactNode;
}

export const useShareModalContext = () => {
  const config = useContext(ConfigContext);
  return config;
};

export const ShareModalContextProvider: React.FC<ShareModalContextProviderProps> = ({
  children,
}) => {
  const [internalIsPending, setInternalIsPending] = useState<{
    [K in IsPendingAllowedKey]?: boolean;
  }>({});

  const isPending = useMemo(
    () => Object.values(internalIsPending).some((value) => value),
    [internalIsPending]
  );

  const setIsPending = useCallback(
    (key: IsPendingAllowedKey, value: boolean) => {
      setInternalIsPending((prev) => ({ ...prev, [key]: value }));
    },
    [setInternalIsPending]
  );

  return (
    <ConfigContext.Provider value={{ isPending, setIsPending }}>{children}</ConfigContext.Provider>
  );
};
